export default {
  install(app, options) {
    if (options.enabled && options.id) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${options.id}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      const gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag = gtag;
      const isProductionEnvironment = import.meta.env.MODE === "production";
      gtag("js", new Date());
      gtag("config", options.id, {
        send_page_view: false, // We'll trigger this manually in the router
        debug_mode: !isProductionEnvironment,
      });

      // Provide gtag to the app
      app.config.globalProperties.$gtag = gtag;

      // Helper methods
      app.provide("gtag", gtag);
    }
  },
};
